import { type FC, memo, useCallback } from "react";
import { token } from "@stubhub/broadway-foundation/tokens";
import { Heading, Link, Text } from "@stubhub/broadway-web";
import { ChevronRightIcon } from "@stubhub/broadway-web/icons/functional";
import { useFormattedContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { linkItemContainer, linkItemLocation, linkItemStateProvinceName } from "./styles";

interface Props {
  name: string;
  stateProvince?: string;
  url: string;
  eventCount: number;
}

export const LinkItem: FC<Props> = memo(({ name, stateProvince, url, eventCount }) => {
  /** "\{0\} events" */
  const storePageEvent = useStorePageEvent();
  const eventCountText = useFormattedContent("cid$#3833865#", [String(eventCount)]);

  const firePageEvent = useCallback(() => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.PERFORMER_CITY_LINK_ITEM_CLICK, JSON.stringify({ name, stateProvince, url }));
  }, [name, stateProvince, url, storePageEvent]);

  return (
    <Link className={linkItemContainer} href={url} onClick={firePageEvent}>
      <div className={linkItemLocation}>
        <Heading as="h3" variant="title" size="small" truncate>
          {name}
        </Heading>
        <Text className={linkItemStateProvinceName} variant="label" size="extra-small" truncate>
          {stateProvince ? `${stateProvince} · ${eventCountText}` : eventCountText}
        </Text>
      </div>
      <ChevronRightIcon size={12} color={token("colors.text.subtle")} />
    </Link>
  );
});
LinkItem.displayName = "LinkItem";
